module.exports = __webpack_public_path__ + "sample-1.f38ec22cabf19ef4d8e2.jpg";


//////////////////
// WEBPACK FOOTER
// /var/www/html/prod/resources/assets/frontend/src/assets/images/sample-1.jpg
// module id = ../../../../../src/assets/images/sample-1.jpg
// module chunks = 29